import * as React from 'react';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';

import { history } from 'app/service/navigation-service';
import { AppWithRouter } from 'app/app-with-router';
import { Spinner } from 'app/components/common/spinner';
import { store } from 'app/redux';
import { FatalErrorBoundary } from 'app/components/domain/error/fatal-error-boundary';

import './styles/fonts.scss';
import './styles/ant-global.scss';

const App: React.FC = () => (
    <FatalErrorBoundary>
        <Provider store={store}>
            <PersistGate persistor={persistStore(store)} loading={<Spinner />}>
                <ConnectedRouter history={history}>
                    <AppWithRouter />
                </ConnectedRouter>
            </PersistGate>
        </Provider>
    </FatalErrorBoundary>
);

export { App };
